module.exports = __webpack_public_path__ + "img/graph-icon.025e7e27.svg";